<template>
  <div class="form-button">
    <el-row :gutter="20">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="btn" v-if="isOpen">
        <el-button :disabled="backStatus" class="back-btn" size="medium" @click="backCurrent"><i class="el-icon-arrow-left"></i>{{$t('back')}}</el-button>
      </el-col>
      <el-col class="button-algin btn" :xs="12" :sm="12" :md="12" :lg="12" :xl="12" v-if="isOpen">
        <el-button class="next-btn" v-if="current < maxCurrent-1" type="primary" size="medium" @click="nextCurrent">{{$t('next')}}<i
            class="el-icon-arrow-right"></i></el-button>
        <el-button class="next-btn" v-else type="primary" size="medium" @click="submit" :disabled="isDisable">{{$t('finish')}}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Bus from './../util/bus.js'
  export default {
    props: ["current", "maxCurrent", " checked","isDisable"],
    data() {
      return {
        backStatus: true,
        current2: 0,
        isClick: false,
        isOpen: false, //是否开启按钮
      };
    },
    methods: {
      submit() {

        this.$emit("nextCurrent", 5, () => {
          this.current2 = 5;
        });
        Bus.$emit('clickVal',this.isClick);
        //this.$emit("submit");
      },
      nextCurrent() {
        this.$emit("nextCurrent", this.current2, () => {
          this.current2 += 1;
          this.backStatus = false;
          if(this.current2==5){
            this.isClick = true;
          }else{
            this.isClick = false;
          }
          return this.current2;
        });
        Bus.$emit('clickVal',this.isClick);
      },
      backCurrent() {
        this.$emit("backCurrent", this.current2-1, () => {
          if (this.current2 == 1) {
            this.backStatus = true;
            return this.current2 -= this.current2;
          }
          this.current2 -= 1;
          return this.current2;
        }, );
      },
    },
    watch: {
      // current2(val) {
      //   this.$emit('update:current', val)
      // },
    }
  };

</script>

<style lang="scss">
  .form-button {
    overflow: hidden;
    width: 80%;
    margin:0 auto;
    padding: 30px 0;
    .btn{
      float: left;
    }
    .button-algin {
      text-align: right;
      @media (max-width: 768px) {
        text-align: left;
      }
    }

    .next-btn {
      width: 150px;
      height: 45px;
      float:left;
      margin-left: 20%;
      @media (max-width: 768px) {
        width: 100%;
        margin-left: 0;
      }
    }

    .back-btn {
      width: 150px;
      height: 45px;
      float:right;
      margin-right: 20%;
      background-color: #ebebeb;

      @media (max-width: 768px) {
        width: 100%;
        margin-right: 0;
      }
    }
    button{
      font-family: Muli-Regular;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/form-button.vue